<template>
    <div class="leaderboard-cnt">
      <div class="top-lead">
        <header class="inner-head">
          <span class="icon-Btn" @click="goBack()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="16"
              viewBox="0 0 18 16"
            >
              <path
                d="M7.993 14.119c.395.432.4 1.127.007 1.558-.39.429-1.019.434-1.418-.004L.297 8.779c-.393-.43-.4-1.122 0-1.56L6.582.326C6.975-.105 7.607-.11 8 .32c.39.428.392 1.121-.007 1.559L3.414 6.902h13.584C17.55 6.902 18 7.39 18 8c0 .606-.452 1.097-1.002 1.097H3.414l4.58 5.023z"
              ></path>
            </svg>
          </span>

          <h2>
            Leaderboard
          </h2>
        </header>

        <div class="top-leadbox">
          <div class="lead-col win3">
            <span class="user-icon">
              <img :src="require('../assets/images/userimg.jpg')" alt="" />
              <span class="badges">
                <i>3</i>
              </span>
            </span>
            <h3>Johanna Toyler Vvs</h3>
            <div class="total-value">
              Total Earning: 450
            </div>
            <div class="total-value">
              Task Completed: 15
            </div>
          </div>
          <div class="lead-col win1">
            <span class="user-icon">
              <span class="crwn-icon">
                <img :src="require('../assets/images/crowns.svg')" alt="" />
              </span>
              <img :src="require('../assets/images/userimg.jpg')" alt="" />
              <span class="badges">
                <i>1</i>
              </span>
            </span>
            <h3>Johanna Toyler Vvs</h3>
            <div class="total-value">
              Total Earning: 450
            </div>
            <div class="total-value">
              Task Completed: 15
            </div>
          </div>
          <div class="lead-col win2">
            <span class="user-icon">
              <img :src="require('../assets/images/userimg.jpg')" alt="" />
              <span class="badges">
                <i>2</i>
              </span>
            </span>
            <h3>Johanna Toyler Vvs</h3>
            <div class="total-value">
              Total Earning: 450
            </div>
            <div class="total-value">
              Task Completed: 15
            </div>
          </div>
        </div>
      </div>

      <section class="mid-cnt">
        <ul class="leader-list">
          <li>
            <div class="user-rank">
              <span class="rank">4</span>
              <span class="user-icon">
                <img :src="require('../assets/images/userimg.jpg')" />
              </span>
            </div>

            <div class="lead-info">
              <h3>Todd Rodriguez</h3>
              <p>Task Completed: 14</p>
            </div>

            <div class="status-value">
              <h3>1,324</h3>
              <p>Total Earning</p>
            </div>
          </li>

          <li>
            <div class="user-rank">
              <span class="rank">5</span>
              <span class="user-icon">
                <img :src="require('../assets/images/userimg.jpg')" />
              </span>
            </div>

            <div class="lead-info">
              <h3>Todd Rodriguez</h3>
              <p>Task Completed: 14</p>
            </div>

            <div class="status-value">
              <h3>1,324</h3>
              <p>Total Earning</p>
            </div>
          </li>
        </ul>
      </section>
    </div>
</template>
<script>
import '../assets/css/leader-board.css'
export default {
  name: "LeaderBoard",
  methods:{
    goBack(){
      this.$router.go(-1)
    }
  }
}
</script>